<template>
  <Navbar />
  <ScrollButton />

  <section class="banner-title" style="background-image: url(images/auto.png)">
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Otomasyon Sistemleri</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li><a href="/">Anasayfa</a></li>
            <li class="active">Otomasyon Sistemleri</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="page-section bg-light" id="portfolio">
    <div class="container">
      <div class="text-uppercase line-wrapper">
        <div class="line"></div>
        <div class="text">Otomasyon Panolarımız</div>
        <div class="line"></div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-sm-6 col-12 mb-3" v-for="(item, index) in panels" :key="index">
          <div class="portfolio-item">
            <a class="portfolio-link" data-bs-toggle="modal" :href="'#portfolioModal' + index">
              <div class="portfolio-hover">
                <div class="portfolio-hover-content">
                  <font-awesome-icon icon="plus" />
                </div>
              </div>
              <img class="img-fluid" :src="item.logo" :alt="item.baslik" loading="lazy" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <Footer />

  <div
    class="portfolio-modal modal fade"
    v-for="(item, index) in panels"
    :key="index"
    :id="'portfolioModal' + index"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close-modal" data-bs-dismiss="modal">
          <img src="images/close-icon.svg" alt="Kapat" />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="modal-body">
                <img class="img-fluid d-block mx-auto" :src="item.logo" :alt="item.baslik" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head';
import { ref, onMounted } from "vue";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

useHead({
  title: 'Otomasyon Sistemleri - İntek Bilişim Teknolojileri',
  meta: [
    {
      name: 'description',
      content: 'İntek Bilişim Teknolojileri olarak endüstriyel otomasyon sistemleri ve pano çözümlerinde yenilikçi ve kaliteli hizmet sunuyoruz.'
    },
    {
      name: 'keywords',
      content: 'otomasyon sistemleri, otomasyon panoları, kontrol panosu, PLC otomasyon, intek, intek bilişim, endüstriyel kontrol'
    },
    {
      property: 'og:title',
      content: 'Otomasyon Sistemleri - İntek Bilişim'
    },
    {
      property: 'og:description',
      content: 'Endüstriyel otomasyon ve pano çözümlerimiz hakkında bilgi alın. İntek Bilişim Teknolojileri ile güvenilir sistemler kurun.'
    },
    {
      property: 'og:image',
      content: 'https://www.intekelectronic.com.tr/images/auto.png'
    }
  ]
});

const panels = ref([]);

onMounted(async () => {
  let q = query(
    collection(firestore, "otomasyonpano"),
    where("durum", "==", true)
  );
  const querySnapshot = await getDocs(q);
  const veri = [];
  querySnapshot.forEach((doc) => {
    veri.push({ ...doc.data(), id: doc.id });
  });
  panels.value = veri;
});
</script>

<style scoped>
.text-uppercase.line-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 2rem;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.2rem;
}
.line-wrapper .line {
  flex-grow: 1;
  height: 1px;
  background: #ccc;
}
.portfolio-hover {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.portfolio-link:hover .portfolio-hover {
  opacity: 1;
}
.portfolio-hover-content {
  color: white;
  font-size: 2rem;
}
.img-fluid {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
@media (max-width: 768px) {
  .line-wrapper .text {
    font-size: 1rem;
  }
  .portfolio-hover-content {
    font-size: 1.5rem;
  }
}
</style>
  